module.exports = __webpack_public_path__ + "img/sirene-roed.dcb85247.svg";